import { Play, ShieldCheck } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useConsent } from '@/features/consent'

interface YoutubeEmbedProps {
  youtubeId: string
  title: string
  className?: string
}

export function YoutubeEmbed({ youtubeId, title, className }: YoutubeEmbedProps) {
  const { consent, allowMedia } = useConsent()
  const wrapper = `relative w-full overflow-hidden rounded-lg bg-brand-black pt-[56.25%] ${className ?? ''}`

  if (!consent?.media) {
    return (
      <div className={wrapper}>
        <div className="absolute inset-0 flex items-center justify-center bg-linear-to-br from-brand-purple-dim via-brand-black to-brand-blue-dim p-6 text-brand-white">
          <div className="max-w-sm text-center">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-purple text-brand-black shadow-lg">
              <Play className="ml-0.5 h-5 w-5 fill-current" aria-hidden="true" />
            </div>
            <p className="mt-4 font-semibold">Watch {title}</p>
            <p className="mt-1 text-xs leading-5 text-brand-white/70">
              This video is hosted by YouTube. Loading it allows Google to receive device and usage information.
            </p>
            <Button
              type="button"
              size="sm"
              className="mt-4 bg-brand-yellow text-brand-black hover:bg-brand-yellow/85"
              onClick={allowMedia}
            >
              <ShieldCheck aria-hidden="true" />
              Allow YouTube & play
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={wrapper}>
      <iframe
        className="absolute inset-0 h-full w-full"
        src={`https://www.youtube-nocookie.com/embed/${youtubeId}`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  )
}
